import { Selector, State, StateContext, createSelector } from '@ngxs/store';
import { Receiver } from '@ngxs-labs/emitter';
import { ColleagueEntry, ColleagueResult, ContactEntry } from '../@models';
import { Injectable, Injector } from '@angular/core';
import { ColleaguesService } from '../@services';
import { Pagination } from '../@config';

@State<ColleagueResult>({
  name: 'colleagues',
  defaults: {
    totalCount: 0,
    items: [],
    skipCount: 0,
    loading: false
  }
})
@Injectable()
export class ColleaguesState {

  private static service: ColleaguesService;

  @Selector()
  static totalItems(state: ColleagueResult): number {
    return state.totalCount || 0;
  }

  @Selector()
  static getAll(state: ColleagueResult): ColleagueEntry[] {
    return state.items;
  }

  @Selector()
  static loadedItems(state: ColleagueResult): number {
    return state.items?.length;
  }

    @Selector()
    static isLoading(state: ColleagueResult) {
      return state.loading;
    }

    @Receiver()
    static stopLoading({ setState, getState }: StateContext<ColleagueResult>) {
      const state = getState();
      setState({
        ...state,
        loading: false
      });
    }

  static hasAny() {
    return createSelector([ColleaguesState], (state: ColleagueResult) => {
      return state.items?.length > 0;
    });
  }

  static getColleagueById(id: number) {
    return createSelector([ColleaguesState], (state: ColleagueResult) => {
      return state.items.find((colleague: ColleagueEntry) => colleague.id === id);
    });
  }

  constructor(injector: Injector) {
    ColleaguesState.service = injector.get(ColleaguesService);
  }

  @Receiver()
  static loadFirst({ setState, getState }: StateContext<ColleagueResult>, searchFilter: string) {
    setState({ ...getState(), loading: true });
    this.service.getColleagues(0, searchFilter).subscribe(
      (result: ColleagueResult) => {
        const newState = { ...result, skipCount: 0, loading: false };
        setState(newState);
      },
      (error) => {
        console.error("Error fetching colleague:", error);
        
        // Ensure loading is set to false even on error
        setState({ ...getState(), loading: false });
      }
    );
  }

  @Receiver()
  static loadNext({ setState, getState }: StateContext<ColleagueResult>, searchFilter: string) {
    const state: ColleagueResult = getState();
    let skipCount: number = state.skipCount + Pagination.skipCount;
    if (skipCount > state.totalCount) {
      skipCount = state.totalCount;
    }
    this.service.getColleagues(skipCount, searchFilter).subscribe(
      {
        next: (result: ColleagueResult) => {
          const tasks = [...state.items, ...result.items];
          const newState = { ...result, items: tasks, skipCount };
          setState(newState);
        }
      })
  }

}
